export default "__VITE_ASSET__5755134f__"